module.exports = __webpack_public_path__ + "img/noto.4d530014.jpg";